<div class="row g-4 survey-layout">
  <div class="col-12 col-lg-3">
    <aside class="survey-list">
      <div class="card survey-card shadow-sm border mb-3">
        <header class="card-header bg-primary text-white">
          <h2 class="h6 mb-0"><i class="bi bi-card-checklist me-2"></i>Encuestas</h2>
        </header>
      </div>
      @if (surveys().length) {
      @for (survey of surveys(); track survey.id_universal) {
      <button class="card survey-card survey-item shadow-sm border w-100 mb-3" type="button"
        (click)="selectSurvey(survey)" [disabled]="autoFilling()"
        [class.active]="selectedSurvey()?.id_universal === survey.id_universal">
        <span class="card-body p-3">
          <span class="fw-semibold d-block">{{ survey.fd_name }}</span>
          <small class="text-body-secondary">
            <i class="bi bi-question-circle me-1"></i>{{ survey.fd_query }} preguntas
          </small>
        </span>
      </button>
      }
      } @else {
      <div class="card survey-card shadow-sm border">
        <p class="text-body-secondary text-center mb-0 p-3">{{ message() }}</p>
      </div>
      }
    </aside>
  </div>

  <div class="col-12 col-lg-9 d-flex">
    <section class="card survey-card survey-detail w-100 shadow-sm border">
      <header class="card-header bg-primary text-white">
        <h2 class="h5 mb-0"><i class="bi bi-ui-checks-grid me-2"></i>Completar encuesta</h2>
      </header>
      <div class="card-body">
        @if (selectedSurvey(); as survey) {
        <h3 class="h4">{{ survey.fd_name }}</h3>
        <p class="text-body-secondary">Responde todas las preguntas para enviar la encuesta.</p>
        @if (canAutoFill()) {
        <div class="border rounded p-3 mb-4">
          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div>
              <div class="fw-semibold"><i class="bi bi-robot me-2"></i>Autocompletar</div>
              <small class="text-body-secondary">Genera respuestas aleatorias con Chromium del servidor.</small>
            </div>
            <div class="d-flex gap-2">
              <button class="btn btn-outline-primary" type="button" (click)="toggleAutoFill()"
                [disabled]="autoFilling()">
                <i class="bi bi-robot me-1"></i>Autocompletar
              </button>
              @if (autoFillVisible()) {
              <button class="btn btn-outline-secondary" type="button" (click)="openAutoFillConfiguration()"
                [disabled]="autoFilling()">
                <i class="bi bi-gear me-1"></i>Configuración
              </button>
              <button class="btn btn-primary" type="button" (click)="runAutoFill()"
                [disabled]="autoFilling() || !autoFillMemoryMaxMb()">
                <i class="bi bi-robot me-1"></i>{{ autoFilling() ? 'Ejecutando...' : 'Ejecutar' }}
              </button>
              }
            </div>
          </div>
          @if (autoFillVisible()) {
          <form class="row g-3 mt-1" [formGroup]="autoFillForm" (ngSubmit)="runAutoFill()">
            <div class="col-12 col-md-4">
              <label class="form-label">Respuestas a generar</label>
              <input class="form-control" type="number" min="1" [attr.max]="availableSlots(survey)"
                formControlName="responses" (change)="validateAutoFillResponses(survey)" />
              <div class="form-text">De 1 a {{ availableSlots(survey) }}. Cupos disponibles: {{ availableSlots(survey)
                }} de {{ survey.fd_count }}.</div>
            </div>
            <div class="col-12 col-md-4">
              <label class="form-label">Bots simultáneos</label>
              <input class="form-control" type="number" min="1" max="10" formControlName="bots"
                (input)="refreshAutoFillMemoryCapacity()" />
            </div>
            <div class="col-12 col-md-4">
              <label class="form-label">Memoria por bot</label>
              <div class="input-group">
                <input class="form-control" type="number" min="1" [attr.max]="autoFillMemoryMaximum()"
                  formControlName="memory_value" (input)="clampAutoFillMemory()" />
                <select class="form-select" style="max-width: 6rem" formControlName="memory_unit"
                  (change)="onAutoFillMemoryUnitChange()">
                  <option value="MB">MB</option>
                  <option value="GB" [disabled]="autoFillMemoryMaxMb() < 1024">GB</option>
                </select>
              </div>
              <div class="form-text">Máximo permitido: {{ autoFillMemoryMaximum() }} {{ autoFillMemoryUnit() }} por bot.
              </div>
            </div>
          </form>
          }
        </div>
        }
        @if (loadingDetails()) {
        <div class="text-center py-5"><span class="spinner-border text-primary"></span></div>
        } @else if (questions().length) {
        <form [formGroup]="answerForm" (ngSubmit)="submit()">
          @for (question of questions(); track question.id_universal; let index = $index) {
          <fieldset class="question-block mb-4">
            <legend class="fs-6 fw-semibold mb-3">
              {{ index + 1 }}. {{ question.fd_ask }}
              @if (question.fd_required) {
              <span class="text-danger" aria-label="Obligatoria">*</span>
              }
            </legend>
            @if (isScale(question)) {
            <div class="scale-options">
              @for (value of valuesFor(question); track value.id_universal) {
              <label class="scale-option" [for]="question.id_universal + '-' + value.id_universal">
                <span>{{ value.fd_option }}</span>
                <input class="form-check-input m-0" type="radio" [id]="question.id_universal + '-' + value.id_universal"
                  [name]="question.id_universal" [value]="value.id_universal"
                  [formControlName]="question.id_universal" />
              </label>
              }
            </div>
            } @else {
            @for (value of valuesFor(question); track value.id_universal) {
            <div class="form-check mb-2">
              <input class="form-check-input" type="radio" [id]="question.id_universal + '-' + value.id_universal"
                [name]="question.id_universal" [value]="value.id_universal" [formControlName]="question.id_universal" />
              <label class="form-check-label" [for]="question.id_universal + '-' + value.id_universal">
                {{ value.fd_option }}
              </label>
            </div>
            }
            }
          </fieldset>
          }
          <div class="border-top pt-3 d-flex justify-content-end">
            <button class="btn btn-outline-primary" type="submit" [disabled]="submitting() || autoFilling()">
              <i class="bi bi-send me-1"></i>{{ submitting() ? 'Enviando...' : 'Enviar respuestas' }}
            </button>
          </div>
        </form>
        } @else {
        <p class="text-body-secondary mb-0">
          Esta encuesta aún no tiene preguntas disponibles.
        </p>
        }
        } @else {
        <div class="empty-survey text-center text-body-secondary py-5">
          <i class="bi bi-arrow-left-circle fs-1 d-block mb-3"></i>
          <p class="mb-0">Selecciona una encuesta de la lista para visualizarla y responderla.</p>
        </div>
        }
        @if (message() && selectedSurvey()) {
        <div class="alert alert-info mt-3 mb-0">
          <i class="bi bi-info-circle me-2"></i>{{ message() }}
        </div>
        }
      </div>
    </section>
  </div>
</div>

@if (autoFillConfigurationVisible()) {
<div class="modal d-block" tabindex="-1" role="dialog" aria-modal="true" style="z-index: 1060">
  <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h2 class="modal-title h5 mb-0"><i class="bi bi-gear me-2"></i>Configuración de respuestas</h2>
        <button class="btn-close btn-close-white" type="button" aria-label="Cerrar"
          (click)="closeAutoFillConfiguration()"></button>
      </div>
      <div class="modal-body">
        <p class="text-body-secondary">Marca las opciones que podrá usar el bot en cada pregunta. Si no marcas una
          opción para una pregunta, el bot usará todas sus opciones aleatoriamente.</p>
        @for (question of questions(); track question.id_universal) {
        <div class="border-top pt-3 mt-3">
          <div class="fw-semibold mb-2">{{ question.fd_order }}. {{ question.fd_ask }}</div>
          <div class="d-flex flex-wrap gap-3">
            @for (value of valuesFor(question); track value.id_universal) {
            <label class="form-check mb-0">
              <input class="form-check-input" type="checkbox"
                [checked]="isAutoFillValueAllowed(question.id_universal, value.id_universal)"
                (change)="toggleAutoFillValue(question.id_universal, value.id_universal, $any($event.target).checked)" />
              <span class="form-check-label">{{ value.fd_option }}</span>
            </label>
            }
          </div>
        </div>
        }
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary" type="button" (click)="closeAutoFillConfiguration()">Listo</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" style="z-index: 1055"></div>
}
